'use strict';
angular.module('groupManageMentLeftModule', [])
    .controller('groupManageMentLeftCtrl', [
        '$scope',
        '$q',
        '$stateParams',
        '$location', '$state',
        '$timeout',
        'treeService',
        'trsHttpService',
        'trsGroupTreeLocationService',
        'permissionService',
        'editingCenterService',
        'publicToolService',
        'messagePublishService',
        function (
            $scope,
            $q,
            $stateParams,
            $location,
            $state,
            $timeout,
            treeService,
            trsHttpService,
            trsGroupTreeLocationService,
            permissionService,
            editingCenterService,
            publicToolService,
            messagePublishService
        ) {
            initStatus();
            initData();

            /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
            function initStatus() {
                $scope.status = {
                    treeOptions: Object.assign(editingCenterService.channelTreeOptions(), {
                        injectClasses: {
                            ul: 'a1',
                            li: 'a2',
                            liSelected: 'a7',
                            iExpanded: 'a3',
                            iCollapsed: 'a4',
                            iLeaf: 'a5',
                            label: 'a6',
                            labelSelected: 'rolegrouplabselected',
                        }, isLeaf: function (node) {
                            return node.HASCHILDREN === 'false';
                        },
                        isSelectable: function (node) {
                            return node.PARENTID !== '0';
                        },
                    }),
                    expandedTest: [],
                    userStatusOpen: !angular.isDefined($location.search().groupid),
                    isGroupNameSearch: false,
                    listPattern: 1,
                    userStatus: {
                        'all': 1,
                        'open': 30,
                        'disable': 20,
                        'delete': 10,
                        'togroup': 40,
                        'topersonal': 50,
                    },
                    firstNode: '',
                    isShowAccountSynchroList: false, // 是否展开账号同步，默认不展开
                    isCorrespendent: !!$state.current.name.includes('correspondent'),
                };
                for (var i in $scope.status.userStatus) { // 初始化渲染选中左侧用户选中列表项
                    if (parseInt($location.search().status) === $scope.status.userStatus[i]) {
                        $scope.status.currStatus = i;
                    }
                }
                if (angular.isUndefined($scope.status.currStatus)) {
                    $scope.status.currStatus = 'undistributed';
                }
                $scope.data = {};
                $scope.$root.$watch('goToGroup', function (newV) {
                    if (!newV) {
                        return;
                    }
                    goToGroup(newV);
                });
                watchGgroupOrdering();
                getPermission();
            }

            /**
         * [watchGgroupOrdering description] 监控右侧子组织调整顺序
         * @return {[type]} [description]
         */
            function watchGgroupOrdering() {
                $scope.$on('gGroupOrding', function () {
                    delete $scope.status.selectedNode.CHILDREN;
                    $scope.showToggle($scope.status.selectedNode);
                });
            }

            /**
         * [initData description] 初始化数据
         * @return  {[type]}  [return description]
         */
            function initData() {
                if (!$scope.status.userStatusOpen) {
                    getGroupIdsPath($location.search().groupid).then(function () {
                        getTreeData();
                    });
                }
               
                publicToolService.getModeconfiguration('groupmanageLeft', 'managementConfiguration').then((config) => {
                    $scope.status.leftStatus = config;
                });
            }

            /**
         * [getPermission description] 获取权限
         * @return {[type]} [description]
         */
            function getPermission() {
                permissionService.getPermissionData().then((data) => {
                    $scope.status.mcnCorrespondent = data.type.mcn;
                });
            }

            /**
         * [goToUserManager description] 进入用户管理
         * @return {[type]} [description]
         */
            $scope.goToUserManager = function () {
                $scope.status.userStatusOpen = true;
                $scope.status.isCorrespendent = false;
                $state.go('manageconfig.groupmanage.user', {
                    'status': 0,
                    groupid: '',
                }, { reload: 'manageconfig.groupmanage.user' });
            };

            /**
         * [goToCorrespondentManager description] 进入通讯员管理
         * @return {[type]} [description]
         */
            $scope.goToCorrespondentManager = function () {
                $scope.status.userStatusOpen = true;
                $scope.status.isCorrespendent = true;
                $state.go('manageconfig.groupmanage.correspondent', {}, { reload: 'manageconfig.groupmanage.correspondent' });
            };

            /**
         * [showToggle description]树展开方法
         * @param  {[obj]} node [description]父节点
         * @return {[type]}        [description]
         */
            $scope.showToggle = function (node) {
                if (node.HASCHILDREN === 'false' || (angular.isDefined(node.CHILDREN) && node.CHILDREN.length !== 0)) {
                    return;
                }
                treeService.queryChildGroupsWithSecondRight(node.GROUPID).then(function (data) {
                    node.CHILDREN = data.CHILDREN;
                });
            };

            /**
         * [showSelected description]点击组织树节点
         * @param  {[obj]} node [description]点击的节点
         * @return {[type]}        [description]
         */
            $scope.showSelected = function (node) {
                // $state.go($state.current, { gropuid: node.GROUPID }, { reload: $state.current.name });
                delete $scope.status.currStatus;
                var router = positionRouter(node);
                $state.go(router.path, router.params, { reload: router.path });
                if ($scope.status.isShowAccountSynchroList == true) { // 收起账号同步
                    $scope.status.isShowAccountSynchroList = false;
                }
            };

            /**
         * [positionRouter description] 定位路由
         * @param   {[type]}  node  [node description]
         * @return  {[type]}        [return description]
         */
            function positionRouter(node) {
                var router = {
                    path: '',
                    params: '',
                };
                if ($state.current.url.indexOf('/group') > -1) {
                    router.path = 'manageconfig.groupmanage.group';
                    router.params = {
                        groupid: node.GROUPID,
                    };
                } else if ($state.current.url.indexOf('/user') > -1 || $state.current.url.indexOf('/accountsynchroto') > -1) {
                    router.path = 'manageconfig.groupmanage.user';
                    router.params = {
                        status: 0,
                        groupid: node.GROUPID,
                    };
                }
                return router;
            }

            var promise;
            $scope.getSuggestions = function (groupName) {
                if (promise) {
                    $timeout.cancel(promise);
                    promise = null;
                }
                promise = $timeout(function () {
                    if (groupName !== '') {
                        var params = {
                            serviceid: 'mlf_extuser',
                            methodname: 'searchGroup',
                            Name: groupName,
                        };
                        if ($scope.status.isRequest) {
                            $scope.status.isRequest = false;
                            return [];
                        } else {
                            return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                                return data;
                            });
                        }
                    }
                }, 10);
                return promise;
            };

            /**
         * [description]Suggestion 鐩戝惉Suggestion
         */
            $scope.$watch('status.searchGroup', function (newValue, oldValue, scope) {
                if (angular.isObject(newValue)) {
                    $scope.status.isRequest = true;
                    goToGroup(newValue);
                }
            });

            /**
         * [goToGroup description] 跳转到指定组织
         * @param   {[type]}  newValue  [newValue description]
         * @return  {[type]}            [return description]
         */
            function goToGroup(newValue) {
                locationGroupTree(newValue.GROUPIDS);
                $scope.status.searchGroup = newValue.GNAME;
                $state.go('manageconfig.groupmanage.group', { 'groupid': newValue.ID }, { reload: 'manageconfig.groupmanage.group' });
            }

            /**
         * [getTreeData description]获取树数据
         * @param  {[obj]} $event [description] 事件对象
         * @param  {[string]} roleid   [description]角色Id非必传
         * @return {[type]}        [description]
         */
            $scope.getTreeData = function ($event) {
                $event.stopPropagation();
                $scope.status.userStatusOpen = false;
                $scope.status.searchGroup = '';
                if (angular.isUndefined($scope.data.treeData)) {
                    getTreeData();
                }
            };

            /**
         * [getTreeData description]
         * @param   {[type]}  isRequest  [isRequest description]
         * @return  {[type]}             [return description]
         */
            function getTreeData(isRequest) {
                treeService.queryGroupTreeWithSecondRight().then(function (data) {
                    $scope.data.treeData = [data];
                    $scope.status.expandedTest.push($scope.data.treeData[0]);
                    if (isRequest) {
                        $scope.status.selectedNode = $scope.data.treeData[0];
                        delete $scope.status.currStatus;
                        $scope.status.firstNode = $scope.data.treeData[0];
                        $state.go('manageconfig.groupmanage.group', { 'groupid': !!$stateParams.groupid ? $stateParams.groupid : $scope.status.selectedNode.GROUPID });
                    } else {
                        if (angular.isUndefined($scope.status.gropuIds)) {
                            return;
                        }
                        locationGroupTree($scope.status.gropuIds);
                    }
                });
            }

            /**
         * [locationGroupTree description] 定位组织树
         * @param   {[type]}  gropuIds  [gropuIds description]
         * @return  {[type]}            [return description]
         */
            function locationGroupTree(gropuIds) {
                $scope.status.expandedTest = [];
                var groupidsArray = gropuIds.split(',');
                groupidsArray.splice(0, 1);
                if (groupidsArray.length === 0) {
                    $timeout(function () {
                        $scope.status.selectedNode = $scope.data.treeData[0];
                        delete $scope.status.currStatus;
                    });
                    return;
                }
                trsGroupTreeLocationService.groupTreeLocation(groupidsArray, $scope.data.treeData[0], $scope.status.selectedNode, $scope.status.expandedTest, function (tree, array, selectedNode) {
                    delete $scope.data.treeData;
                    $scope.data.treeData = [tree];
                    $scope.status.expandedTest.push($scope.data.treeData[0]);
                    $scope.status.selectedNode = selectedNode;
                    delete $scope.status.currStatus;
                });
            }

            /**
         * [getGroupIdsPath description]
         * @param   {[type]}  groupid  [groupid description]
         * @return  {[type]}           [return description]
         */
            function getGroupIdsPath(groupid) {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_groupmanagement',
                    methodname: 'getGroupIdsPath',
                    GroupId: Number(groupid),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    $timeout(function () {
                        $scope.status.gropuIds = data[0].GROUPIDS;
                        // getTreeData();
                        deffer.resolve(data);
                    });
                });
                return deffer.promise;
            }

            /**
         * [showAccountSynchro description]展开收起账号同步
         * @return {[type]} [description]
         */
            $scope.showAccountSynchro = function () {
                $scope.status.isShowAccountSynchroList = !$scope.status.isShowAccountSynchroList;
            };
        }]);
